import {isDefaultTenant, tenantFeatureEnabled} from '../../../../app/tenant/tenantState'

/**
 * The header "Dumyah Ads" button shows only when ALL hold: the user has the
 * `dumyah_ads` RBAC permission, the tenant has the `ads` feature enabled, and the
 * tenant IS Dumyah — the button links to ads.dumyah.com, the only self-serve ads
 * platform, so it must never send another tenant's suppliers there.
 * Fail-open (`tenantFeatureEnabled` defaults true) keeps it visible for plain Dumyah.
 *
 * Kept in its own tiny module (not Navbar.tsx) so it is unit-testable without
 * pulling Navbar's heavy provider/auth import graph into the test.
 */
export function adsButtonVisible(canView: boolean): boolean {
  return canView && tenantFeatureEnabled('ads') && isDefaultTenant()
}
